import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import { SelectOption, TextareaField, addOption } from '../../../../utils/InputField';
import { ApiCloseSupportTicket } from '../../SupportTicketOperation';

const preDefinedData = [
    {
        id: 1,
        name: 'Issue was resolved.',
        value: 'Issue was resolved.'
    },
    {
        id: 2,
        name: 'The issue was not resolved but the customer closed.',
        value: 'The issue was not resolved but the customer closed.'
    },
    {
        id: 3,
        name: 'The issue was not resolved and the customer not responding.',
        value: 'The issue was not resolved and the customer not responding.'
    },
    {
        id: 4,
        name: "Closed from the customer's end.",
        value: "Closed from the customer's end."
    },
    {
        id: 5,
        name: 'Nothing. Write your own reason.',
        value: 'Other'
    }
];

function CloseTicketModal({ data, handleReload }) {
    const { setMessage, setConfirm } = useTemplate();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        SupportTicketId: data?.id,
        Reason: '',
        Message: ''
    });
    const handleOnChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };

    const handleReason = (e) => {
        const { value } = e.target;
        if (value === 'Other') {
            setFormData((d) => ({ ...d, Message: '', Reason: value }));
            return;
        }
        setFormData((d) => ({ ...d, Message: value, Reason: value }));
    };

    const handleUpdate = (e) => {
        setLoading(true);
        e.preventDefault();

        ApiCloseSupportTicket(data?.id, formData)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                setConfirm(null);
                handleReload();
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString() });
            });
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleUpdate} className="flex flex-col gap-4 w-full">
            <p className="text-base font-normal">Are you sure you want to close this ticket?</p>

            <SelectOption
                label="Reason"
                name="Reason"
                placeholder="Reason"
                options={preDefinedData?.map((item) =>
                    addOption(item?.id, item?.name, item?.value)
                )}
                onChange={handleReason}
                formData={formData}
                required
            />
            <TextareaField
                label="Message"
                name="Message"
                placeholder="Write reason for closing ticket..."
                formData={formData}
                onChange={handleOnChange}
                className="h-32 [&>textarea]:p-2 *:resize-none"
                required
            />
            <div className=" w-full flex justify-end items-center gap-2">
                <ButtonCancel title="No" onClick={() => setConfirm(null)} />
                <ButtonPrimary
                    title="Yes"
                    btnType="submit"
                    loading={loading}
                    className="bg-error"
                />
            </div>
        </form>
    );
}

export default CloseTicketModal;
